Vue.component('fp-available-filter', {
  data: function () {
    return {
      showFilter: false,
      status: 'all'
    }
  },
  methods: {
    filterOnlyAvailable() {
      this.status = 'available';
      bus.$emit('filter.change', {
        key: 'status',
        val: ['free']
      })
    },
    resetFilter() {
      this.status = 'all';
      bus.$emit('filter.change', {
        key: 'status',
        val: []
      })
    }
  },
  mounted() {
    bus.$on('head.show.filter', () => {
      this.showFilter = true;
    });
    bus.$on('search.results', () => {
      if (this.status !== 'all' || ww < 992) {
        this.filterOnlyAvailable();
      }
    });

    if(ww < 992) {
      var mobileAvailableTimer = setInterval(Timer, 100);

      function Timer() {
        if ($(".sm-available").hasClass("active")) {
          clearInterval(mobileAvailableTimer);
        } else {
          $(".sm-available").click();
        }
      }
    }

  },
  template:
    `
<div>
  <div
    v-if="showFilter"
    class="fp__simple-filter">
      <button @click="resetFilter()" :class="{'active' : (status === 'all')}">{{ $t("ALL") }}</button>
      <span>|</span>
      <button @click="filterOnlyAvailable()" :class="{'active' : (status === 'available')}" class="sm-available">{{ $t("AVAILABLE") }}</button>
    </div>
</div>
`
});

Vue.component('fp-detail', {
  props: {
    home: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      showAttrs: window.innerWidth > 992,
      panzoomImageSrc: '',
      panzoom: null,
      panzoomEl: null,
      panzoomOpt: {
        contain: 'automatic',
        minScale: 1,
        cursor: "grab",
        maxScale: 2,
        increment: 1
      },
      zoomDirection: false,
      readyToZoom: true,
      panzoomZoomTimeout: null,
      firstZoomReady: true,
      tooltipStyle: {
        left: 0,
        top: 0,
        opacity: 0
      },
      floorImages: {},
      schemaImages: [],
      plot: 'PLOT',
      enquiryForm: false
    }
  },
  methods: {
    onMouseMove(e) {
          console.log('page x: ' + this.page.left);
          console.log('page y: ' + this.page.top);
          this.page.left = e.pageX;
          this.page.top = e.pageY;
    },
    closeDetail() {
      bus.$emit('detail.close')
    },
    zoom() {
      if (this.readyToZoom) {
        this.firstZoomReady = false;
        this.panzoomEl.panzoom('zoom', this.zoomDirection);
        this.panzoomEl.panzoom('resetPan');
        this.zoomDirection = !this.zoomDirection;
      }
    },
    setPanzoom() {
      if (window.innerWidth < 992) return;

      this.panzoomEl = $(this.$refs.panzoom);
      this.panzoomEl.panzoom(this.panzoomOpt);
      this.panzoomEl.on('panzoompan', () => {
        this.readyToZoom = false;
      });
      this.panzoomEl.on('panzoomend', () => {
        clearTimeout(this.panzoomZoomTimeout);
        this.panzoomZoomTimeout = setTimeout(() => {
          this.readyToZoom = true;
        }, 50)
      });
    },
    setTooltip($event) {
      if (!this.firstZoomReady) return;

      this.tooltipStyle = {
        top: $event.clientY + 'px',
        left: $event.clientX + 'px',
        opacity: 1,
      };
    },
    hideTooltip($event) {
      if (!this.firstZoomReady) return;

      this.tooltipStyle.opacity = 0;
    },
    sortImages() {
      // prasárna - špatné podklady z CRM
      this.home.data.images.map(img => {
        if (img.name === "schema01") this.schemaImages.unshift(img);
        else if (img.name === "schema02") this.schemaImages.push(img);
        else {
          this.floorImages["plan" + img.name] = img;
          if (img.name === "1") this.panzoomImageSrc = img.url;
        }
      });
      if (this.home.data.plan) {
          if (this.panzoomImageSrc === '') this.panzoomImageSrc = this.home.data.plan.url;
          this.floorImages["plan"] = this.home.data.plan;
      }
    },
    showEnquiryForm() {
      this.enquiryForm = true;

      dataLayer.push({
        'flatName': this.home.name,
        'event': 'viewFlatFormPopup'
      });
    }
  },
  mounted() {
    this.sortImages();
    // bodyScrollLock.disableBodyScroll(document.querySelector('.fp__detail'));

    bus.$on('enquiry-form.close', () => {
      this.enquiryForm = false;
    });
  },
  destroyed() {
    // bodyScrollLock.enableBodyScroll(document.querySelector('.fp__detail'));
    if (this.panzoomEl) this.panzoomEl.panzoom("destroy");
  },
  template:
    `
<div class="fp__detail">
  <button @click="closeDetail" type="button" class="btn-close btn-close--black btn-close--right-top"></button>
  <div class="container-fluid-oaks min-h-100">
    <div class="row align-content-lg-center min-h-100">
      <div class="col-lg-3 col-xl-2 mx-auto text-center d-flex flex-column justify-content-start mb-5 pt-5 mb-lg-0">
        <div> 
          <h6 class="text-uppercase ff-gotham-medium">
            <span v-if="home.data.type === 'family house'">{{ $t(home.data.nameAccordingWeb)}}</span>
            <span v-else>{{ $t(home.data.category) }}</span>
          </h6>
          <h6 class="font-weight-normal mt-1">
            <div class="fp__detail__attrs__list">
              <div v-if="home.data.architect" class="fp__detail__attrs__list__item text-uppercase ff-gotham-book">{{ $t("ARCHITECT") }}: {{ home.data.architect }}</div>
            </div>          
          </h6>
          <div class="s-20"></div>
          <hr class="divider"> 
          <div class="s-20"></div>
          <h4>
            <span class="text-capitalize" v-if="home.data.type !== 'flat'">{{ $t("HOUSE") }}</span>
            <span v-if="home.data.type === 'flat'">{{ home.data.name }}</span>
            <span v-else> {{ home.data.building }} </span>
          </h4> 
          <div class="s-20"></div>
          <div>
            <div class="s-20"></div>
            <button @click="showEnquiryForm" type="button" class="btn">{{ $t("ENQUIRE") }}</button>
          </div>
          <div> 
            <div class="s-20"></div>
            <a v-if="this.home.data.pdf" :href="this.home.data.pdf.url" target="_blank" class="btn-secondary">{{ $t("DOWNLOAD_PDF") }}</a>
            <div class="mt-4">
                <a v-if="this.home.data.pdf" :href="gv.root_url + '/' + $t('energy root')" target="_blank" class="btn-secondary">{{ $t("ENERGY LABEL") }}</a>
            </div>
          </div> 
        </div>  
      </div>
      <div class="col-11 col-lg-9 col-xl-10 mx-auto text-center">
        <div class="row justify-content-center d-none d-lg-flex mb-5" v-if="home.data.type !== 'flat'">
            <button @click="panzoomImageSrc = floorImages.plan1.url" type="button" class="btn-tertiary mx-3 active">{{ $t("GROUND_FLOOR") }}</button>
            <button @click="panzoomImageSrc = floorImages.plan2.url" type="button" class="btn-tertiary mx-3 active">{{ $t("FIRST_FLOOR") }}</button>
            <button @click="panzoomImageSrc = floorImages.plan3.url" type="button" class="btn-tertiary mx-3 active">{{ $t("SECOND_FLOOR") }}</button>
            <button @click="panzoomImageSrc = floorImages.plan0.url" type="button" class="btn-tertiary mx-3 active">{{ $t("BASEMENT") }}</button>
        </div> 
        
        <div class="row justify-content-center d-none d-lg-flex mb-5" v-if="home.data.type === 'flat' && home.data.plans.length !== 0">
            <button @click="panzoomImageSrc = home.data.plans[0].url" 
                    type="button" class="btn-tertiary mx-3 active">
                    {{ $t("translate" + home.data.floor.slice(0,2)) }}
            </button>
            <button @click="panzoomImageSrc = home.data.plans[1].url" 
                    type="button" class="btn-tertiary mx-3 active">
                    <span v-if="home.data.floor.slice(0,2) === '-1'">
                        {{ $t("translate" + home.data.floor.slice(5,6) + ' ') }}
                    </span>
                    <span v-else>
                        {{ $t("translate" + home.data.floor.slice(4,5) + ' ') }}
                    </span>
            </button>
        </div>         
        
        <div
          class="fp__detail__panzoom"
        >
          <img ref="panzoom" @load="this.setPanzoom" :src="panzoomImageSrc" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
  
  <transition name="modal-fade">
    <fp-enquiry-form v-show="enquiryForm" :internalid="this.home.data.name" :project="this.home.data.projectId"></fp-enquiry-form>
  </transition>
</div>
`
});

Vue.component('fp-enquiry-form', {
    props: {
        internalid: {
            type: String
        },
        project: {
            type: String
        }
    },
    data: function () {
        return {
            formId: 'm08f46',
            form: {
                name: {
                    value: '',
                    validations: {
                        empty: true
                    }
                },
                surname: {
                    value: '',
                    validations: {
                        empty: true
                    }
                },
                email: {
                    value: '',
                    validations: {
                        empty: true,
                        email: true
                    }
                },
                phone: {
                    value: '',
                    validations: {
                        empty: true
                    }
                },
                internalid: {
                    value: this.internalid,
                    validations: {}
                },
                project: {
                    value: this.project,
                    validations: {}
                },
                note: {
                    value: '',
                    validations: {}
                },
                contactMeBy: {
                    value: 'phone',
                    validations: {}
                },
                referral: {
                    value: '',
                    validations: {
                        empty: true
                    }
                },
                referralOther: {
                    value: 'Other...',
                    validations: {}
                },
                consent: {
                    value: '',
                    validations: {
                        isTrue: true
                    }
                }
            },
            sentSuccess: false,
            sentFailure: false,
            widgetId3: null
        }
    },
    mounted() {
        if ( $('#g-recaptcha3').length ) {
            this.widgetId3 = grecaptcha.render('g-recaptcha3', {
                'sitekey': '6LeWnX4iAAAAAJ9-np3iSh83adnnaWciMmAcRcVh'
            });
        } 

        $("form input").click(function() {
            $("#contact-form-recaptcha-container").collapse("show");
        });
    },
    methods: {
        getLangKey() {
            return gv.lang;
        },
        isLangCs() {
            return (gv.lang === 'cs_CZ');
        },
        validate() {
            let result = true;
            for (let input in this.form) {
                if (!this.form.hasOwnProperty(input)) {
                    continue;
                }
                if (!this.validateInput(this.form[input])) {
                    result = false;
                }
            }
            return result;
        },
        validateInput(input) {
            for (let validation in input.validations) {
                if (!input.validations.hasOwnProperty(validation)) {
                    continue;
                }
                input.validations[validation] = this.validateInputSingleValidation(input.value, validation);
                if (!input.validations[validation]) {
                    return false;
                }
            }
            return true;
        },
        validateInputSingleValidation(value, validation) {
            switch (validation) {
                case 'email':
                    return Validator.email(String(value));
                case 'empty':
                    return Validator.empty(value);
                case 'isTrue':
                    return Validator.isTrue(value);
                default :
                    return true;
            }
        },
        preparePostData() {
            let data = new FormData();
            data.append('mact', 'FormBuilder,' + this.formId + ',default,1');
            data.append(this.formId + 'fbrp_callcount', '1');
            data.append(this.formId + 'form_id', '5');
            data.append(this.formId + 'fbrp_continue', '2');
            data.append(this.formId + 'fbrp_done', '1');
            data.append(this.formId + 'fbrp__25', 'true');
            data.append(this.formId + 'fbrp__35', this.getLangKey());
            data.append(this.formId + 'fbrp__24', this.form.email.value);
            data.append(this.formId + 'fbrp__26', this.form.name.value);
            data.append(this.formId + 'fbrp__27', this.form.surname.value);
            data.append(this.formId + 'fbrp__28', this.form.phone.value);
            data.append(this.formId + 'fbrp__29', this.form.note.value);
            data.append(this.formId + 'fbrp__30', this.form.contactMeBy.value);
            data.append(this.formId + 'fbrp__31', this.form.referral.value);
            data.append(this.formId + 'fbrp__32', this.form.referralOther.value);
            data.append(this.formId + 'fbrp__33', this.form.consent.value);
            data.append(this.formId + 'fbrp__36', this.form.internalid.value);
            data.append(this.formId + 'fbrp__38', this.form.project.value);
            data.append(this.formId + 'fbrp_submit', 'submit');
            return data;
        },
        /*
        pushEventToDataLayer() {
            dataLayer.push({'event': 'formSent', 'formName': 'enquiryForm'});
        },
        */
        callbackBtnClose() {
            bus.$emit('enquiry-form.close')
        },
        callbackSubmit() {
            if (!this.validate() || grecaptcha.getResponse(this.widgetId3).length === 0) {
                return;
            }

            let url = gv.root_url + '/api/enquiry-form/';
            axios
                .post(url, this.preparePostData())
                .then(function(response) {
                    if (response.status === 200 && response.data.success) {
                        dataLayer.push({
                            'formName': 'flatFormPopup',
                            'flatName': this.internalid,
                            'event': 'formSent'
                        });
                        if (typeof response.data.crmUserId !== "undefined") {
                            dataLayer.push({
                                'event': 'sendCrmUserId',
                                'crmUserId': response.data.crmUserId
                            });
                        }
                        this.sentSuccess = true;
                    } else {
                        this.sentFailure = true;
                    }
                }.bind(this))
                .catch(function(error) {
                    this.sentFailure = true;
                }.bind(this));
        }
    },
    template:
        `
<div
    class="enquiry-fom"
    style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #dcd9d2;
        z-index: 999;
        overflow: auto;
    "
>
    <button v-on:click="callbackBtnClose" type="button" class="btn-close btn-close--black btn-close--right-top" style="z-index: 999"></button>

    <div class="container-fluid-oaks">
        <div class="row text-center">
            <div class="col-12">
                <div class="sd-30 sm-20"></div>
                <h2>{{ $t("Register your interest") }}</h2>
            </div>
        </div>
    </div>
    
    <div class="sd-80 sm-50"></div>
    
    <div class="container">
        <div class="row">
            <div class="col-lg-8 mx-auto text-center">
                <p>{{ $t("interest text") }}</p>
            </div>
        </div>
        <div class="sd-50 sm-30"></div>
        
        <div v-if="sentSuccess" class="row">
            <div class="col-lg-8 mx-auto text-center">
                <h4>{{ $t("interest thank you") }}</h4>
                <div class="s-30"></div>
                <p>{{ $t("We will contact you shortly.") }}</p>
            </div>
        </div>
        
        <div v-if="sentFailure" class="row">
            <div class="col-lg-8 mx-auto text-center">
                <h4>{{ $t("interest failure") }}</h4>
            </div>
        </div>

        <div v-if="!sentSuccess && !sentFailure" class="row">
            <div class="col-lg-6 mx-auto">
                <div class="row">
                    <div class="col">
    
                        <form v-on:submit.prevent="callbackSubmit" id="enquiry-form" action="#" method="post" novalidate>
                            <input v-model="form.project.value" id="cnt-project" :name="formId + 'fbrp__38'" type="hidden" :value="project">
                            <div class="row">
                                <div class="col-lg-6">
                                    <label for="cnt-given-name">{{ $t("FIRST NAME") }}*</label>
                                    <input v-model="form.name.value" id="cnt-given-name" :name="formId + 'fbrp__26'" type="text" class="form-control">
                                    <small v-if="!form.name.validations.empty" class="form-control-error-message">{{ $t("This field is required.") }}</small>
                                    <div class="sd-30 sm-10"></div>
                                </div>
                                <div class="col-lg-6">
                                    <label for="cnt-family-name">{{ $t("SURNAME") }}*</label>
                                    <input v-model="form.surname.value" id="cnt-family-name" :name="formId + 'fbrp__27'" type="text" class="form-control">
                                    <small v-if="!form.surname.validations.empty" class="form-control-error-message">{{ $t("This field is required.") }}</small>
                                    <div class="sd-30 sm-10"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <label for="cnt-email">{{ $t("EMAIL ADDRESS") }}*</label>
                                    <input v-model="form.email.value" id="cnt-email" :name="formId + 'fbrp__24'" type="email" class="form-control">
                                    <small v-if="!form.email.validations.empty" class="form-control-error-message">{{ $t("This field is required.") }}</small>
                                    <small v-if="!form.email.validations.email" class="form-control-error-message">{{ $t("This field must be a valid email address.") }}</small>
                                    <div class="sd-30 sm-10"></div>
                                </div>
                                <div class="col-lg-6">
                                    <label for="cnt-phone">{{ $t("PHONE NUMBER") }}*</label>
                                    <input v-model="form.phone.value" id="cnt-phone" :name="formId + 'fbrp__28'" type="tel" class="form-control">
                                    <small v-if="!form.phone.validations.empty" class="form-control-error-message">{{ $t("This field is required.") }}</small>
                                    <div class="sd-30 sm-10"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <label for="cnt-subject">{{ $t("SUBJECT") }}</label>
                                    <input v-model="form.internalid.value" id="cnt-subject" :name="formId + 'fbrp__36'" type="text" class="form-control" :value="internalid" disabled="disabled">
                                    <div class="sd-30 sm-10"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label for="cnt-message">{{ $t("Message Optional") }}</label>
                                    <textarea v-model="form.note.value" id="cnt-message" :name="formId + 'fbrp__29'" cols="30" rows="6" class="form-control"></textarea>
                                    <div class="sd-30 sm-10"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label for="cnt-contact-me-by">{{ $t("Preferred Method of Contact") }}*</label>
                                    <div class="s-10"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input v-model="form.contactMeBy.value" type="radio" id="cnt-contact-me-by-phone" :name="formId + 'fbrp__30'" class="custom-control-input" value="phone" checked>
                                        <label class="custom-control-label" for="cnt-contact-me-by-phone">{{ $t("Phone") }}</label>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input v-model="form.contactMeBy.value" type="radio" id="cnt-contact-me-by-email" :name="formId + 'fbrp__30'" class="custom-control-input" value="email">
                                        <label class="custom-control-label" for="cnt-contact-me-by-email">E-mail</label>
                                    </div>
                                </div>
                            </div>
                            <div class="sd-30 sm-30"></div>
                            <div>
                                <label for="cnt-hear-about">{{ $t("How Did You Hear About Us") }}*</label>
                                <select v-model="form.referral.value" class="custom-select" :name="formId + 'fbrp__31'" id="cnt-hear-about">
                                    <option value="">{{ $t("Please select") }}</option>
                                    <option value="2">{{ $t("Online") }}</option>
                                    <option value="1">{{ $t("Print") }}</option>
                                    <option value="3">{{ $t("Social media") }}</option>
                                    <option value="4">{{ $t("Word of mouth") }}</option>
                                    <option value="19">{{ $t("Other") }}</option>
                                </select>
                                <small v-if="!form.referral.validations.empty" class="form-control-error-message">{{ $t("This field is required.") }}</small>
                            </div>
                            <div v-if="form.referral.value === '19'">
                                <label for="cnt-other"></label>
                                <input v-model="form.referralOther.value" id="cnt-other" :name="formId + 'fbrp__32'" type="text" class="form-control" value="Other...">
                            </div>
                            <div class="sd-30 sm-30"></div>
                            <div>
                                <div class="custom-control custom-checkbox">
                                    <input v-model="form.consent.value" id="cnt-consent-dataprocessing" :name="formId + 'fbrp__33'" type="checkbox" class="custom-control-input errorr" value="1">
                                    <small v-if="!form.consent.validations.isTrue" class="form-control-error-message">{{ $t("This field is required.") }}</small>
                                    <label class="custom-control-label" for="cnt-consent-dataprocessing">
                                        {{ $t("I agree to the processing") }}
                                        <a v-if="isLangCs()" :href="gv.root_url + '/pravidla-a-podminky/#protection'" class="t-underline">
                                            <u>{{ $t("terms and conditions") }}</u>
                                        </a>
                                        <a v-else :href="gv.root_url + '/terms-and-conditions/#protection'" class="t-underline">
                                            <u>{{ $t("terms and conditions") }}</u>
                                        </a> 
                                    </label>
                                </div>
                                <div class="sd-30 sm-30"></div>
                            </div>
                            <div class="required-field-info">
                                <p><div>*</div> {{ $t("Required field") }}</p>
                            </div>
                            
                            <div class="form-row collapse" id="contact-form-recaptcha-container">
                                <div id="g-recaptcha3" class="m-auto"></div>
                            </div>
                            <br><br>
                            
                            <div class="text-center">
                                <button type="submit" class="btn">{{ $t("Submit") }}</button>
                            </div>
                        </form>
    
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`
});

Vue.component('fp-head', {
  template:
`
<div class="row">
  <div class="col text-center">
    <h2>{{ $t("FLOORPLANS") }}</h2>
    <div class="sd-50 sm-30"></div>
    <fp-available-filter></fp-available-filter>
    <div class="sd-40 sm-20"></div>
  </div>
</div>
`
});

const fp_translates = {
    free: [
        "available",
        "dostupný"
    ],
    VIEW: [
        "VIEW",
        "DETAIL"
    ],
    PLOT: [
        "PLOT",
        "POZEMEK"
    ],
    ALL: [
        "ALL",
        "VŠE"
    ],
    ARCHITECT: [
        "ARCHITECT",
        "ARCHITEKT"
    ],
    APARTMENT: [
        "APARTMENT",
        "BYT"
    ],
    Apartments: [
        "APARTMENTS",
        "BYTY"
    ],
    AVAILABLE: [
        "AVAILABLE",
        "DOSTUPNÝ"
    ],
    'Courtyard apartments': [
        "GREEN COURT APARTMENTS",
        "REZIDENCE V ZAHRADÁCH"
    ],
    CLEAR: [
        "CLEAR",
        "VYMAZAT"
    ],
    "CLICK TO VIEW LARGER": [
        "CLICK TO VIEW LARGER",
        "KLIKNUTÍM ZVĚTŠETE"
    ],
    'Green view apartments': [
        "GOLF VIEW APARTMENTS",
        "REZIDENCE U GOLFU"
    ],
    HOUSE: [
        "HOUSE",
        "DŮM"
    ],
    Houses: [
        "HOUSES",
        "DOMY"
    ],
    LEVEL: [
        "LEVEL",
        "PODLAŽÍ"
    ],
    LAYOUT: [
        "LAYOUT",
        "DISPOZICE"
    ],
    Layout: [
        "LAYOUT",
        "DISPOZICE"
    ],
    Location: [
        "LOCATION",
        "UMÍSTĚNÍ"
    ],
    INTERNAL_AREA: [
        "INTERNAL AREA",
        "UŽITNÁ PLOCHA"
    ],
    FLOORPLAN: [
        "FLOORPLAN",
        "PŮDORYS"
    ],
    FLOORPLANS: [
        "Floorplans",
        "Vybrané nemovitosti"
    ],
    "FURTHER INFORMATION": [
        "FURTHER INFORMATION",
        "PODROBNĚJŠÍ INFORMACE"
    ],
    GARDEN: [
        "GARDEN",
        "ZAHRADA"
    ],
    BALCONY_TEERRACE: [
        "BALCONY/TEERRACE",
        "BALKON/TERASA"
    ],
    MOVING_IN: [
        "COMPLETION",
        "DOKONČENÍ"
    ],
    TO_MOVE_IN: [
        "TO MOVE IN",
        "K NASTĚHOVÁNÍ"
    ],
    IMMEDIATELY: [
        "IMMEDIATELY",
        "IHNED"
    ],
    AVAILABILITY: [
        "AVAILABILITY",
        "DOSTUPNOST"
    ],
    NORTH_ELEVATION: [
        "NORTH_ELEVATION",
        "SCHÉMATICKÝ ŘEZ"
    ],
    reserveed: [
        "RESERVEED",
        "REZERVOVANÝ"
    ],
    reserved: [
        "RESERVED",
        "REZERVOVANÝ"
    ],
    RESULTS: [
        "results",
        "jednotek"
    ],
    sold: [
        "SOLD",
        "PRODANÝ"
    ],
    'Property type': [
        "PROPERTY TYPE",
        "TYP NEMOVITOSTI"
    ],
    'Village houses': [
        "FAMILY HOUSES",
        "RODINNÉ DOMY"
    ],
    'Village square apartments': [
        "PARK VIEW APARTMENTS",
        "REZIDENCE U PARKU"
    ],
    'VIEW INFORMATION': [
        "VIEW INFORMATION",
        "ZOBRAZIT INFORMACE"
    ],
    'If the home that you’re interested in is no longer available,': [
        "If the home that you’re interested in is no longer available,",
        "Pokud dům, o který máte zájem, už není k dispozici,"
    ],
    'please': [
        "please contact us",
        "tak nás prosím kontaktujte"
    ],
    'contact us': [
        "here",
        "zde"
    ],
    'dot-cz': [
        "",
        "."
    ],
    'or call +420 702 260 000 for more information on future development at Oaks.': [
        "for more information on future development at Oaks.",
        "Rádi vám poskytneme více informací o připravované výstavbě v Oaks."
    ],
    'VIEW HOMES': [
        "FILTER",
        "FILTROVAT"
    ],
    'SEARCH PROPERTIES': [
        "Search properties",
        "Vyhledat nemovitost"
    ],
    ENQUIRE: [
        "ENQUIRE",
        "POPTAT"
    ],
    BASEMENT: [
        "BASEMENT",
        "SUTERÉN"
    ],
    SECOND_FLOOR: [
        "SECOND FLOOR",
        "DRUHÉ PODLAŽÍ"
    ],
    FIRST_FLOOR: [
        "FIRST FLOOR",
        "PRVNÍ PODLAŽÍ"
    ],
    GROUND_FLOOR: [
        "GROUND FLOOR",
        "PŘÍZEMÍ"
    ],
    DOWNLOAD_PDF: [
        "DOWNLOAD_PDF",
        "STÁHNOUT PDF"
    ],
    'Register your interest': [
        'Contact Us',
        'Kontaktujte nás'
    ],
    'interest text': [
        'Interested in living at Oaks? Fill in your details below and we’ll be in touch very soon.',
        'Zajímáte se o život v Oaks? Vyplňte prosím údaje níže a brzy vás budeme kontaktovat.'
    ],
    'interest thank you': [
        'Thank you for your interest.',
        'Děkujeme za vyplnění formuláře.'
    ],
    'interest failure': [
        'Something went wrong. Please try again later.',
        'Něco se pokazilo. Zkuste akci opakovat později.'
    ],
    'We will contact you shortly.': [
        'We will contact you shortly.',
        'V nejbližší době Vás budeme kontaktovat.'
    ],
    'This field is required.': [
        'This field is required.',
        'Toto pole je povinné.'
    ],
    'This field must be a valid email address.': [
        'Enter a valid email address.',
        'Zadejte platnou e-mailovou adresu.'
    ],
    'FIRST NAME': [
        'FIRST NAME',
        'JMÉNO'
    ],
    'SURNAME': [
        'SURNAME',
        'PŘÍJMENÍ'
    ],
    'EMAIL ADDRESS': [
        'EMAIL ADDRESS',
        'E-MAILOVÁ ADRESA'
    ],
    'PHONE NUMBER': [
        'PHONE NUMBER',
        'TELEFONNÍ ČÍSLO'
    ],
    'Message Optional': [
        'Message (Optional)',
        'Zpráva'
    ],
    'Preferred Method of Contact': [
        'Preferred Method of Contact',
        'Preferuji tuto formu kontaktu'
    ],
    'How Did You Hear About Us': [
        'How Did You Hear About Us?',
        'Jak jste se o nás dozvěděli?'
    ],
    'Please select': [
        'Please select',
        'Prosím vyberte'
    ],
    'Online': [
        'Online',
        'Z internetu'
    ],
    'Print': [
        'Print',
        'Z tisku'
    ],
    'Social media': [
        'Social media',
        'Ze sociálních sítí'
    ],
    'Word of mouth': [
        'Word of mouth',
        'Ústně'
    ],
    'Other': [
        'Other',
        'Jiným způsobem'
    ],
    'I agree to the processing': [
        'I agree to the processing of my personal data above to receive more information on the Oaks Prague project and to arrange a personal presentation. For further information, please see our full',
        'Souhlasím se zpracováním svých osobních údajů, uvedených výše, za účelem získání podrobnějších informací o projektu Oaks Prague a sjednání osobní prezentace. Pro bližší informace si prosím prohlédněte naše'
    ],
    'terms and conditions': [
        'terms and conditions',
        'podmínky a prohlášení'
    ],
    'Required field': [
        'Required field',
        'Povinné pole'
    ],
    'Submit': [
        'Submit',
        'Odeslat'
    ],
    'Phone': [
        'Phone',
        'Telefon'
    ],
    'SUBJECT': [
        'SUBJECT',
        'PŘEDMĚT'
    ],
    'ENERGY LABEL': [
        'ENERGY LABEL',
        'ENERGETICKÝ ŠTÍTEK'
    ],
    'energy root': [
        'energy-labels',
        'energeticke-stitky'
    ],
    'translate-1': [
        'GROUND FLOOR',
        'PODZEMNÍ PODLAŽÍ'
    ],
    'translate1 ': [
        'FIRST FLOOR',
        "PRVNÍ PODLAŽÍ"
    ],
    'translate2 ': [
        'SECOND FLOOR',
        "DRUHÉ PODLAŽÍ"
    ],
    'translate3 ': [
        'THIRD FLOOR',
        'TŘETÍ PODLAŽÍ'
    ],
    'translate4 ': [
        'FOURTH FLOOR',
        'ČTVRTÉ PODLAŽÍ'
    ]
};

Vue.mixin({
    methods: {
        $t: function (key) {
            return _.get(fp_translates, key) ? _.get(fp_translates, key)[langIndex] : key;
        },
        $sqm: function (val) {
            if (!val || val === 0) return "-";
            return gv.lang === "en_US" ? val + " SQM" : val + " m<sup>2</sup>";
        }
    },
});

Vue.filter("emptyDash", val => val !== "" ? val : "-");
Vue.filter("uppercase", val => val.toUpperCase());

Vue.component('fp-search', {
  props: {
    homesData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      searchCount: 0,
      homesLength: 0,
      homesLengthCounter: 0,
      selectedFilters: "all",
      filters: [
        {
          id: 'type',
          title: 'Property type',
          dropdown: false,
          all: true,
          items: [
            {
              title: 'Apartments',
              active: false,
              value: 'flat',
              type: 'apartment',
              disabled: false
            },
            {
              title: 'Houses',
              active: false,
              value: 'family house',
              type: 'house',
              disabled: false
            },
          ]
        },
        {
          id: 'layout',
          title: 'Layout',
          dropdown: false,
          all: true,
          items: []
        },
        {
          id: 'location',
          title: 'Location',
          dropdown: false,
          all: true,
          items: []
        },
      ]
    }
  },
  methods: {
      clearFilter(filter) {
          filter.items.map(i => i.active = false);
          filter.items.map(i => i.disabled = false);
          filter.all = true;

          let selected = "";

          var propertyFilterActive = this.filters[0].items.filter(function(key){
              return key.active == true;
          });
          var dispositionFilterActive = this.filters[1].items.filter(function(key){
              return key.active == true;
          });
          var locationFilterActive = this.filters[2].items.filter(function(key){
              return key.active == true;
          });

          if (dispositionFilterActive.length !== 0) {
              this.filters[0].items[1].disabled = true;
              this.filters[2].items[3].disabled = true;
          }

          if (locationFilterActive.length !== 0) {
              console.log(".....t....");
              if (locationFilterActive.map(i => i.type).indexOf("apartment") !== -1) {
                  this.filters[0].items[1].disabled = true;
                  this.filters[2].items[3].disabled = true;
              } else if (locationFilterActive.map(i => i.type).indexOf("house") !== -1) {
                  console.log(".....d.....");
                  this.filters[0].items[0].disabled = true;
                  this.filters[2].items[0].disabled = true;
                  this.filters[2].items[1].disabled = true;
                  this.filters[2].items[2].disabled = true;
                  this.filters[1].items.map(i => i.disabled = true);
              }
          }

          if (propertyFilterActive.length === 0 && dispositionFilterActive.length === 0 && locationFilterActive.length === 0) {
              this.filters[0].items.map(i => i.disabled = false);
              this.filters[1].items.map(i => i.disabled = false);
              this.filters[2].items.map(i => i.disabled = false);
              this.selectedFilters = "all";

          }

          selected = this.selectedFilters;

          var propertyFilter = this.filters[0].items.filter(function(key){
              return key.type == selected;
          });
          var dispositionFilter = this.filters[1].items.filter(function(key){
              return key.type == selected;
          });
          var locationFilter = this.filters[2].items.filter(function(key){
              return key.type == selected;
          });

          console.log(selected);

          console.log(propertyFilter);
          console.log(dispositionFilter);
          console.log(locationFilter);

          this.filters[0].items.map(i => i.disabled = false);
          this.filters[1].items.map(i => i.disabled = false);
          this.filters[2].items.map(i => i.disabled = false);

          propertyFilter.map(i => i.disabled = true);
          dispositionFilter.map(i => i.disabled = true);
          locationFilter.map(i => i.disabled = true);

      },
      setFilter(filter, item) {
          filter.all = false;
          item.active = !item.active;
          let selected = "";

          if (item.type === "house") {
              this.selectedFilters = "apartment";
          } else if (item.type === "apartment") {
              this.selectedFilters = "house";
          }

          selected = this.selectedFilters;

          var propertyFilter = this.filters[0].items.filter(function(key){
             return key.type == selected;
          });
          var dispositionFilter = this.filters[1].items.filter(function(key){
              return key.type == selected;
          });
          var locationFilter = this.filters[2].items.filter(function(key){
              return key.type == selected;
          });

          this.filters[0].items.map(i => i.disabled = false);
          this.filters[1].items.map(i => i.disabled = false);
          this.filters[2].items.map(i => i.disabled = false);

          propertyFilter.map(i => i.disabled = true);
          dispositionFilter.map(i => i.disabled = true);
          locationFilter.map(i => i.disabled = true);

          let checkAllActiveFalse = _.chain(filter.items).map((item) => {
              return item.active
          }).filter(Boolean).value();

          if (!checkAllActiveFalse.length) this.clearFilter(filter);

          // this.search(true);
      },
    changeFilterCategory() {

    },
    dropDownItem(title, value, active=false, disabled=false, type) {
      return {title, value, active, disabled, type}
    },
    getFilterVariants(prop, target) {
      _.chain(this.homesData)
        .map(prop)
        .remove((v) => { return v !== "" })
        .uniq()
        .value()
        .reverse()
        .map((i) => {
          target.push(this.dropDownItem(i,i))
        });
    },
    search(prefetch=false) {

      let propertyTypeActive = _.chain(this.filters[0].items).map((item) => {
          return item.active ? item.value : false
        }).compact().value();

      let layoutActive = _.chain(this.filters[1].items).map((item) => {
          return item.active ? item.value : false
        }).compact().value();

      let locationActive = _.chain(this.filters[2].items).map((item) => {
          return item.active ? item.value : false
        }).compact().value();

      let homes = this.homesData;

      if (propertyTypeActive.length || layoutActive.length || locationActive.length) {

        homes = _.filter(homes,(home) => {
          let available = true;

          if (propertyTypeActive.length && propertyTypeActive.indexOf(home.data.type) < 0) available = false;

          if (layoutActive.length && layoutActive.indexOf(home.data.disposition) < 0) available = false;

          if (locationActive.length && locationActive.indexOf(home.data.nameAccordingWeb) < 0) available = false;

          return available;
        });

      }

      if (!prefetch) {
        this.searchCount++;
        bus.$emit('search.results', homes);
        if (ww > 992) {
          
          if (gv.page_alias !== 'vyber-bydleni' && gv.page_alias !== 'master-plan') {
            scrollTo(null, '#floor-plans', true)
          }
        } else {
          setTimeout(function () {
            scrollTo(null, '#floor-plans-table')
          }, 100)
        }
      } else {
        // console.log(homes)
      }
    },
    countFilteredHomes() {
      if (this.homesLengthCounter > this.homesLength) this.homesLengthCounter--;
      else if (this.homesLengthCounter < this.homesLength) this.homesLengthCounter++;

      if (this.homesLengthCounter !== this.homesLength) {
        setTimeout(() => {
          this.countFilteredHomes()
        }, 50)
      }
    },
    checkAvailablePropertyType() {

      // property type
      this.filters[0].items.forEach((filter) => {
        let notSoldItems = _.chain(this.homesData).map((item) => {
          return item.data.status === 'free' && item.data.type === filter.value
        }).compact().value();
        //filter.disabled = !Boolean(notSoldItems.length)
      });

      // layout
      this.filters[1].items.forEach((filter) => {
        let notSoldItems = _.chain(this.homesData).map((item) => {
          return item.data.status === 'free' && item.data.disposition === filter.value
        }).compact().value();
        //filter.disabled = !Boolean(notSoldItems.length)
      });

      // location
      this.filters[2].items.forEach((filter) => {
        let notSoldItems = _.chain(this.homesData).map((item) => {
          return item.data.status === 'free' && item.data.nameAccordingWeb === filter.value
        }).compact().value();
        //filter.disabled = !Boolean(notSoldItems.length)
      })

      this.filters[1].items.map(i => i.type = "apartment");
      this.filters[2].items.map(i => i.type = "apartment");
      this.filters[2].items[3].type = "house";

    },
    checkAvailableLocation() {

    }
  },
  mounted() {
    bus.$on('homes.updated.length', (len) => {
      this.homesLengthCounter = this.homesLength = len;
      // if (this.homesLengthCounter !== this.homesLength) this.countFilteredHomes()
    });

    
    if (gv.page_alias === 'vyber-bydleni' || gv.page_alias === 'master-plan') { 
      this.search(false);
      this.searchCount++;
    }
  },
  watch: {
    homesData() {
      this.getFilterVariants('data.disposition', this.filters[1].items);
      this.filters[1].items = _.orderBy(this.filters[1].items, 'value');
      this.getFilterVariants('data.nameAccordingWeb', this.filters[2].items);
      this.checkAvailablePropertyType();
      this.checkAvailableLocation();
    }
  },
  template:
    `
<div>
  <div class="row">
    <div class="col text-center">
      <h4>{{ $t("SEARCH PROPERTIES") }}</h4>
      <div class="sd-50 sm-30"></div>
    </div>
  </div>
  <div class="row">
    <div
      v-for="filter in filters"
      :key="filter.id"
      class="col-lg">
      <div class="dd-list">
        <button
          @click="filter.dropdown = !filter.dropdown"
          :class="{'active': filter.dropdown}"
          class="dd-list__btn">
          {{ $t(filter.title) }}
        </button>
        <transition name="dd-in">
          <div
            v-show="filter.dropdown"
            class="dd-list__items">
            <div
              @click="clearFilter(filter)"
              class="dd-list__item">
              <div>
                <div v-if="filter.all">{{ $t("ALL") }}</div>
                <div v-else class="text-underline">{{ $t("CLEAR") }}</div>
              </div>
              <div v-if="filter.all">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" checked="checked" tabindex="-1">
                  <label class="custom-control-label"></label>
                </div>
              </div>
            </div>
            <div
              v-for="item in filter.items"
              @click="!item.disabled ? setFilter(filter, item) : 0"
              class="dd-list__item"
              :class="{'disabled': item.disabled}">
              <div>{{ $t(item.title) }}</div>
              <div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :checked="item.active" tabindex="-1">
                  <label class="custom-control-label"></label>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="sm-20"></div>
    </div>
    <div class="col-lg">
      <button @click="search(false)" class="btn-tertiary btn-tertiary--alt w-100">{{ $t("VIEW HOMES") }}</button>
    </div>
  </div>
  <transition name="dd-in">
    <div class="row sd-mt-20 sm-mt-10" v-show="searchCount">
      <div class="col-auto search-results">
        <span>{{homesLengthCounter}}</span> {{ $t("RESULTS") }}
      </div>
      <div class="col-auto ml-auto">
        <fp-available-filter></fp-available-filter>
      </div>
    </div>
  </transition>
  <div class="sd-20 sm-10"></div>
</div>
`
});

Vue.component('fp-table', {
  props: {
    homes: {
      type: Array,
      default: function () {
        return []
      }
    },
    category: {
      type: String
    }
  },
  data: function () {
    return {
      filteredHomes: [],
      orderColumns: {},
      orderByColumn: 'data.building',
      detail: 'VIEW',
      filters: {
        status: []
      },
      wrapperVisible: 0,
      wrapperStyle: {
        maxHeight: 0
      },
      showLoadMoreButton: false,
      plot: 'PLOT',
      gv: gv

    }
  },
  methods: {
    filterHomes() {
      let homes = this.homes;

      homes = _.filter(homes, (o) => {
        return !this.filters.status.length ? true : (this.filters.status.indexOf(o.data.status) >= 0)
      });

      homes = _.orderBy(homes, [this.orderByColumn],[this.orderColumns[this.orderByColumn].dir ? 'asc' : 'desc']);

      this.filteredHomes = homes;

      bus.$emit('homes.updated.length', this.filteredHomes.length)
    },
    orderHomes(column, dir) {
      this.orderByColumn = column;

      if (this.orderColumns.hasOwnProperty(column)) this.orderColumns[column].dir = !this.orderColumns[column].dir;
      else this.orderColumns[column] = { dir: true };

      dir = dir ? dir : (this.orderColumns[column].dir ? 'asc' : 'desc');

      this.filteredHomes = _.orderBy(this.filteredHomes, [column],[dir])
    },
    setWrapperHeight() {
      if (window.innerWidth > 992) {
        this.wrapperStyle.maxHeight = 400;
        return;
      }

      this.wrapperVisible = this.wrapperVisible + 10;

      if (this.wrapperVisible > this.filteredHomes.length) {
        this.wrapperVisible = this.filteredHomes.length;
        this.showLoadMoreButton = false;
      }

      this.wrapperStyle.maxHeight = this.wrapperVisible * 40 + 'px';
    },
    setDetail(home) {
      bus.$emit('detail.set.home', home);

      console.log(home);

      dataLayer.push({
          'flatName': home.name,
          'event': 'viewFlatPopup'
      });

    },
    ww(minW) {
      return window.innerWidth > minW
    },
    isSoldOrReserved(home) {
      return ['sold', 'reserved'].indexOf(home.data.status) >= 0
    },
    isHouses() {
      return [4,5,6,7].indexOf(this.category) >= 0
    },
    isApartmentsOrAll() {
      return [1,2,3,8,9,13].indexOf(this.category) >= 0
    },
    isAll() {
      return [1].indexOf(this.category) >= 0
    },
  },
  mounted() {
    bus.$on('filter.change', (opt) => {
      _.set(this.filters, opt.key, opt.val);
      this.filterHomes();
    })
  },
  watch: {
    homes: function (val) {
      this.filteredHomes = val;
      this.orderHomes('data.name', 'asc');
      this.filterHomes();
      this.setWrapperHeight();
    }
  },
  filters: {},
  template:
`
<div id="floor-plans-table">
  <div class="row">
    <div class="col">
      <div class="fp__table" :class="{'houses': isHouses(), 'master-plan': isAll()}">
        <div class="fp__table__head">
          <div class="fp__table__head__row" style="padding-right: 13px">
            <div
              @click="orderHomes('data.name')" 
              class="fp__table__head__col order-able">
                <span v-if="isHouses()">{{ $t("HOUSE") }}</span>
                <span v-else>{{ $t("APARTMENT") }}  </span>
            </div>
            <div
              v-if="isApartmentsOrAll()"
              @click="orderHomes('data.floor')" 
              class="fp__table__head__col order-able d-none d-lg-flex"><span>{{ $t("LEVEL") }}</span></div>
            <div
              v-if="isApartmentsOrAll()"
              @click="orderHomes('data.disposition')" 
              class="fp__table__head__col order-able"><span>{{ $t("LAYOUT") }}</span></div>
            <div
              @click="orderHomes('data.areas.total')" 
              class="fp__table__head__col order-able"><span>{{ $t("INTERNAL_AREA") }}</span></div>
            <div
              @click="orderHomes('data.areas.garden')" 
              v-if="isApartmentsOrAll()"
              class="fp__table__head__col order-able d-none d-lg-flex"><span>{{ $t("GARDEN") }}</span></div>
            <div
              @click="orderHomes('data.areas.plot')" 
              v-else
              class="fp__table__head__col order-able d-none d-lg-flex"><span>{{ $t(plot) }}</span></div>              
            <div
              @click="orderHomes('data.areas.plot')" 
              class="fp__table__head__col order-able d-none d-lg-flex" v-if="isAll()"><span>{{ $t(plot) }}</span></div>              
            <div
              v-if="isApartmentsOrAll()"
              @click="orderHomes('data.areas.balconyAndTerrace')" 
              class="fp__table__head__col order-able d-none d-lg-flex"><span>{{ $t("BALCONY_TEERRACE") }}</span></div>
            <div
              v-if="isApartmentsOrAll()"
              @click="orderHomes('data.movingIn')" 
              class="fp__table__head__col order-able d-none d-lg-flex"><span>{{ $t("TO_MOVE_IN") }}</span></div> 
            <div
              @click="orderHomes('data.status')" 
              class="fp__table__head__col order-able d-none d-lg-flex"><span>{{ $t("AVAILABILITY") }}</span></div>
            <div class="fp__table__head__col"><span>{{ $t("FLOORPLAN") }}</span></div>     
          </div>
        </div>
        <div
          class="fp__table__scroll-wrapper scrollbar scrollbar--rounded"
          :style="wrapperStyle"
        >
          <div class="fp__table__body">
            <div 
              v-for="(home, index) in filteredHomes"
              :class="{'even': (index % 2), 'disabled': isSoldOrReserved(home)}"
              :key="index"
              class="fp__table__body__row"
            >
              <div class="fp__table__body__col"><span v-if="home.data.type === 'flat'">{{ home.data.name }}</span> <span v-else>{{ home.data.building }}</span></div>
              <div class="fp__table__body__col d-none d-lg-block" v-if="isApartmentsOrAll()"><span v-if="home.data.floor !== 0">{{ home.data.floor}}</span><span v-else>-</span></div>
              <div class="fp__table__body__col" v-if="isApartmentsOrAll()">{{ home.data.disposition | emptyDash }}</div>
              <div class="fp__table__body__col" v-html="$sqm(home.data.areas.total)"></div>
              <div class="fp__table__body__col d-none d-lg-block"><span v-if="isApartmentsOrAll()" v-html="$sqm(home.data.areas.garden)"></span><span v-else v-html="$sqm(home.data.areas.plot)"></span></div>
              <div class="fp__table__body__col d-none d-lg-block" v-if="isAll()"><span v-html="$sqm(home.data.areas.plot)"></span></div>
              <div class="fp__table__body__col d-none d-lg-block" v-if="isApartmentsOrAll()" v-html="$sqm(home.data.areas.balconyAndTerrace)"></div>
              <div class="fp__table__body__col d-none d-lg-block" v-if="isApartmentsOrAll()"><span v-if="home.data.movingIn"><span v-if="gv.cs">{{ home.data.movingIn}}</span><span v-else>TO MOVE IN</span></span><span v-else><span>{{ $t("IMMEDIATELY") }}</span></span></div>
              <div class="fp__table__body__col d-none d-lg-block">{{ $t(home.data.status) | uppercase }}</div>
              <div class="fp__table__body__col">
                <button @click="isSoldOrReserved(home) ? 0 : setDetail(home)" type="button" class="btn-secondary">{{ $t(detail) }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <transition name="fade">
    <div
      v-if="showLoadMoreButton"
      class="row d-lg-none"
    >
      <div class="col text-center">
        <div class="s-40"></div>
        <button
          @click="setWrapperHeight"
          class="btn"
        >
        Load more</button>    
      </div>  
    </div>  
  </transition>
  
</div>
`
});

/* global gv, floorPlanCategory, floorPlanSearchActive */

const bus = new Vue();

const fp = new Vue({
  el: '#floorplans',
  data: {
    category: floorPlanCategory ? floorPlanCategory : 1,
    homesData: [],
    homes: [],
    home: null,
    searchActive: floorPlanSearchActive,
    isVisible: !(masterPlanActiveLayer && masterPlanActiveLayer === 'facilities'),
    gv: gv
  },
  mounted() {
    this.getHouses();
    bus.$on('detail.set.home', (home) => {
      this.home = home;
      $("html").addClass("detail-opened");
    });

    bus.$on('detail.close', () => {
      this.home = null;
      $("html").removeClass("detail-opened");
    });

    bus.$on('search.results', (homes) => {
      this.homes = homes;
    });
  },
  methods: {
    getHouses() {
      axios.get(gv.root_url+'/api/homes/'+this.category)
        .then((res) => {
          this.homesData = this.processData(res.data);
          this.checkIfAllAvailable();

          //if (!this.searchActive) {
          this.homes = this.homesData;
          //}

          console.log(this.homes);
        })
    },
    processData(data) {
      return data.map(item => {
        item.data.areas.balconyAndTerrace = item.data.areas.balcony + item.data.areas.terrace;
        return item
      })
    },
    checkIfAllAvailable() {
      if (_.findIndex(this.homesData, (o) => {
        return o.data.status !== 'free'
      }) !== -1) bus.$emit('head.show.filter')
    },
    isHousesCategory() {
      return [1,3,4,5,6,7].indexOf(this.category) >= 0
    }
  },
  template:
    `
<div class="container-fluid-oaks fp" id="floor-plans">
  <transition name="dd-in">
    <div v-show="isVisible">
      <div class="sd-50 sm-30"></div>
      
      <fp-search v-if="this.searchActive" :homesData="homesData"></fp-search>
      <fp-head v-else></fp-head>
      
      <transition name="dd-in">
        <fp-table v-show="homes.length" :homes="homes" :category="this.category"></fp-table>
      </transition>
      
      <transition name="modal-fade">
        <fp-detail v-if="home" :home="home"></fp-detail>
      </transition>
  
      <div class="sd-30 sm-20"></div>
      
      <div v-if="isHousesCategory()" class="container-fluid-oaks">
          <div class="row">
              <div class="col text-center">
                  <p>
                      {{ $t("If the home that you’re interested in is no longer available,") }} {{ $t("please") }} <a :href="gv.root_url + (gv.en ? '/en/contact-us' : '/kontakt')"><span class="text-underline">{{$t("contact us")}}</span></a>{{$t("dot-cz")}} {{ $t("or call +420 702 260 000 for more information on future development at Oaks.") }}
                  </p>
              </div>
          </div>
      </div>
    </div>  
  </transition>
</div>
`
});
